import React, { useEffect } from 'react';
import { Table } from 'react-bootstrap';
import 'src/style/tenant.css';
import { useDispatch, useSelector } from 'react-redux';
import {
  getOrganisationList,
  getOrganisationListByTenant,
} from 'src/redux/Actions/Organisation';
import Breadcrumb from 'src/components/Breadcrumb';
import { useSetBreadcrumbData } from 'src/utils/SetBreadcrumbData';
import { useLocation } from 'react-router-dom';
import usePageTitle from 'src/utils/SetPageTitle';

export default function OrganisationList() {
  usePageTitle('Cloud VT • Organisation');
  const location = useLocation();
  const dispatch = useDispatch();
  const authReducer = useSelector((state) => state.AuthReducer);
  const tenantId = authReducer.userData.tenant?.id;
  const isSuperAdmin = authReducer.superAdmin === true;
  useEffect(() => {
    if (isSuperAdmin === true) {
      dispatch(getOrganisationList());
    } else {
      dispatch(getOrganisationListByTenant(tenantId));
    }
  }, [dispatch]);

  const organisationReducer = useSelector((state) => state.OrganisationReducer);
  const organisationData = organisationReducer?.organisationList;

  useSetBreadcrumbData(location.pathname, 'Organisation');

  return (
    <div className="page-layout div-flex-column rg-10">
      <div className="div-space-between div-flex-column border-bottom">
        <div className="div-flex-row cg-5 left-padding padding-bottom-8">
          <Breadcrumb />
        </div>
        <div className="slider-padding">
          <span className="text-xxl text-semi-bold left-padding">
            Organisation
          </span>
        </div>
      </div>
      <div className="div-flex-column left-padding">
        <div className="div-flex-row div-space-between div-align-center">
          <span className="text-xxxl text-bold">Organisation Management</span>
        </div>
        <span className="text-md text-400">
          {organisationData?.length} Organisation
        </span>
      </div>
      <div className="po-table setting-sidebar-container">
        <Table hover size="lg" className="table-cell-record">
          <thead>
            <tr>
              <th className="bg-grey">
                <div className="text-lg text-bold table-cell-min-width-100 table-id-column-padding">
                  ID
                </div>
              </th>
              {isSuperAdmin && (
                <th className="bg-grey">
                  <div className="text-lg text-bold table-cell-min-width-100">
                    Tenant Name
                  </div>
                </th>
              )}
              <th className="bg-grey">
                <div className="text-lg text-bold table-cell-min-width-100">
                  Organisation Name
                </div>
              </th>
              <th className="bg-grey">
                <div className="text-lg text-bold table-cell-min-width-100">
                  GST Number
                </div>
              </th>
            </tr>
          </thead>
          <tbody className="div-scrollable-details">
            {organisationData?.length > 0 ? (
              organisationData.map((organisationDataObj) => (
                <tr key={organisationDataObj.id}>
                  <td className="table-cell-min-width-100">
                    <div className="div-flex-row cg-10 div-align-center">
                      <div className="text-md text-400 text-center">
                        #{organisationDataObj.id}
                      </div>
                    </div>
                  </td>
                  {isSuperAdmin && (
                    <td className="table-cell-min-width-100">
                      <div className="text-md text-400">
                        {organisationDataObj.tenant_name}
                      </div>
                    </td>
                  )}
                  <td className="table-cell-min-width-100">
                    <div className="text-md text-400">
                      {organisationDataObj.name}
                    </div>
                  </td>
                  <td className="table-cell-min-width-100">
                    <div className="text-md text-400">
                      {organisationDataObj.gst_number}
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr className="text-center">
                <td colSpan="6">
                  <div className="text-md text-400">
                    No Organisation Created
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    </div>
  );
}
